import { useEffect, useState } from "react";
import axios from "axios";
import { API_CONFIG } from "../config/apiConfig";

import DocumentAttestationSection from "../components/home/DocumentAttestationSection";
import GlobalPartnerSection from "../components/home/GlobalPartnerSection";
import HeroSection from "../components/home/HeroSection";
import RecruitmentOverseasSection from "../components/home/RecruitmentOverseasSection";
import ServiceCards from "../components/home/ServiceCards";
import TestimonialsContactSection from "../components/home/TestimonialsContactSection";
import TrustedVisaSection from "../components/home/TrustedVisaSection";
import VisaEmigrationJobsSection from "../components/home/VisaEmigrationJobsSection";

export default function Home() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_CONFIG.BASE_URL}/home-page`, {
          headers: API_CONFIG.HEADERS
        });
        if (response.data.success || response.data.status === 'success' || response.data.data) {
          setData(response.data.data || response.data);
        }
      } catch (error) {
        console.error("Error fetching Home page data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center font-poppins text-[#0d213b]">Loading...</div>;
  }

  return (
    <>
      <HeroSection data={data?.hero} />
      <ServiceCards data={data?.hero?.quick_links} />
      <TrustedVisaSection data={data?.trust_section} />
      <RecruitmentOverseasSection data={data?.recruitment_section} />
      <GlobalPartnerSection data={data?.partner_section} />
      <VisaEmigrationJobsSection visaData={data?.visa_emigrations_section} jobsData={data?.jobs_section} />
      <DocumentAttestationSection attestationData={data?.attestation_section} specializedData={data?.specialized_services_section} />
      <TestimonialsContactSection data={data?.testimonials_section} />
    </>
  );
}
